import React from 'react';
import SkeletonLoader from './SkeletonLoader';

const ChallengePageSkeleton = () => {
    return (
        <div className="w-full max-w-4xl mx-auto space-y-4">
            {Array.from({ length: 5 }).map((_, index) => (
                <div key={index} className="bg-gray-800/50 border border-gray-700 rounded-lg p-4 flex flex-col md:flex-row items-center justify-between">
                    <div className="mb-4 md:mb-0 md:mr-4 flex-grow">
                        <SkeletonLoader className="h-6 w-48 mb-2" />
                        <SkeletonLoader className="h-4 w-24" />
                    </div>
                    <div className="flex gap-2 flex-shrink-0 w-full md:w-auto">
                        <SkeletonLoader className="h-10 flex-1" />
                        <SkeletonLoader className="h-10 flex-1" />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ChallengePageSkeleton;
